import { FormControl, FormGroup } from '@angular/forms';
import { Component, Input, ChangeDetectionStrategy, inject } from '@angular/core';
import { PrivacyPolicyService } from '../services/privacy-policy.service';

@Component({
    standalone: false,
    selector: 'por-privacy-terms',
    templateUrl: './privacy-terms-component.component.html',
    styleUrls: ['./privacy-terms-component.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrivacyTermsComponent {
    readonly privacyPolicyService = inject(PrivacyPolicyService);

    @Input() formGroup!: FormGroup;
    @Input() privacyPolicyAccepted: FormControl | undefined;
    @Input() isLogin: boolean | undefined;
}
